import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents, ServiceEventsDocuments } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { MonthlyClosureDetail, MonthlyClosureDetailWorkerDataForm, MonthlyClosureDetailFilters } from '../../models/MonthlyClosureDetail';

const useMonthlyClosureDetailWorkerService = () => {

    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetMonthlyClosureDetailWorkersByClosureDetail, setFetchingGetMonthlyClosureDetailWorkersByClosureDetail] =
        useState(false);
    const [fetchingChangeMonthlyClosureDetailWorkerStatus, setFetchingChangeMonthlyClosureDetailWorkerStatus] =
        useState(false);


    const getMonthlyClosureDetailWorkersByClosureDetail = (
        closureId: number, 
        filter: MonthlyClosureDetailFilters, 
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(filter)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.MONTHLY_CLOSURE_DETAIL_WORKERS.ALL_MONTHLY_CLOSURE_DETAIL_WORKERS_BY_CLOSURE_DETAIL.replace(
            ':monthly_closure_detail_id',
            closureId.toString()
        )}?${queryString}`;
    
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetMonthlyClosureDetailWorkersByClosureDetail
        });
    };


    const changeMonthlyClosureDetailWorkerStatus = (
        id: number, 
        status: string,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.MONTHLY_CLOSURE_DETAIL_WORKERS.CHANGE_MONTHLY_CLOSURE_DETAIL_WORKER_STATUS.replace(
                ':id',
                id.toString()
            ).replace(':status', status),
            setFetching: setFetchingChangeMonthlyClosureDetailWorkerStatus
        });
    };




    return {
        fetchingGetMonthlyClosureDetailWorkersByClosureDetail,
        fetchingChangeMonthlyClosureDetailWorkerStatus,
        getMonthlyClosureDetailWorkersByClosureDetail,
        changeMonthlyClosureDetailWorkerStatus,
    };
};

export default useMonthlyClosureDetailWorkerService;
